import React from 'react';
import PropTypes from 'prop-types';

import { compose } from 'recompose';

import { contentBlocksToText } from 'polaris-coreweb/exports';

import {
  withHelmet,
  withTemplate,
} from 'Protons';

import { Heading } from '@autovia-uk/polaris-components/components/molecules/Heading';
import { SimpleSearch } from '@autovia-uk/polaris-components/components/molecules/SimpleSearch';

import { getArticleGroup } from 'SharedPartialsLocal/getArticleGroup';

// Template styles and imports
import 'Styles/components/templates/_NotFound.scss';

const NotFound = ({
  layoutData: { mostPopular },
}) => (
  <div className="polaris__body -not-found-template">
    <main className="polaris__main" id="main">
      <div className="polaris__core-content polaris__content -center">
        <Heading size={2}>
          Sorry! This page cannot be found
        </Heading>

        <p>
          It looks like this page has moved somewhere else but you can try searching for what you are looking for
        </p>

        <div className="polaris__gray--bg">
          <SimpleSearch
            label=""
            inputId="polaris__not-found--template-input"
            placeholder="Search..."
            extraClassNames={{
              'polaris__search--results': true,
              '-no-padding-margin': true,
            }}
          />
        </div>
      </div>

      {mostPopular
      && (
      <div className="polaris__core-content polaris__content">
        {getArticleGroup({
          title: 'Most Popular',
          content: mostPopular.map(item => ({ ...item, excerpt: contentBlocksToText(item.excerpt) })),
          extraClassNames: {
            'polaris__article--most-popular': true,
            'polaris__page--most-popular': true,
          },
          articleCardProps: {
            datePosition: 'bottom',
            isHeading: false,
            kickerPosition: 'bottom',
          },
        })}
      </div>
      )}
    </main>
  </div>
);

NotFound.propTypes = {
  layoutData: PropTypes.shape({
    mostPopular: PropTypes.arrayOf({}).isRequired,
  }).isRequired,
};

export default compose(
  withTemplate,
  withHelmet('notFound'),
)(NotFound);
